import script from "./CategoryButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryButton.vue?vue&type=script&setup=true&lang=ts"

import "./CategoryButton.vue?vue&type=style&index=0&id=221e76f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-221e76f0"]])

export default __exports__